import { PositionType } from 'data/types';
import {
  SPACE_POLYGON_WALLS_HINT,
  spaceDiagramHintBox
} from './space-polygon-walls-helpers';

type SpacePolygonWallsHintProps = {
  centroid: PositionType;
  clipPathId: string;
};

export default function SpacePolygonWallsHint({
  centroid,
  clipPathId
}: SpacePolygonWallsHintProps) {
  const box = spaceDiagramHintBox(centroid);

  return (
    <g clipPath={`url(#${clipPathId})`} style={{ pointerEvents: 'none' }}>
      <foreignObject
        x={box.x}
        y={box.y}
        width={box.width}
        height={box.height}
        className='overflow-visible'
      >
        <div className='flex h-full w-full items-center justify-center px-2'>
          <span className='rounded bg-white/80 px-2 py-1 text-center text-[11px] leading-tight text-gray-500'>
            {SPACE_POLYGON_WALLS_HINT}
          </span>
        </div>
      </foreignObject>
    </g>
  );
}
